interface UrlParameters {
  projectGuid?: string | null;
  activeComponentDesignGuid?: string | null;
  selectedItemType?: string | null;
  selectedItemGuid?: string | null;
  selectedLoadCaseGuid?: string | null;
}

export function matchUrlPattern(pathname: string): UrlParameters {
  const splitPathname = pathname.split('/');

  // `pathname` always starts with a slash, so the first item should always be empty
  if (splitPathname[0] !== '') throw new Error('Expected first part of split pathname to be an empty string.');

  return {
    projectGuid: splitPathname[1] !== '' ? splitPathname[1] : undefined,
    activeComponentDesignGuid: splitPathname[2] !== '' ? splitPathname[2] : undefined,
    selectedItemType: splitPathname[3] !== '' ? splitPathname[3] : undefined,
    selectedItemGuid: splitPathname[4] !== '' ? splitPathname[4] : undefined,
    selectedLoadCaseGuid: splitPathname[5] !== '' ? splitPathname[5] : undefined,
  };
}

export function stringifyUrlPattern(urlParameters: UrlParameters): string {
  let pathname = '/';

  if (urlParameters.projectGuid == null) return pathname;
  pathname += urlParameters.projectGuid;

  if (urlParameters.activeComponentDesignGuid == null) return pathname;
  pathname += `/${urlParameters.activeComponentDesignGuid}`;

  if (urlParameters.selectedItemType == null) return pathname;
  pathname += `/${urlParameters.selectedItemType}`;

  if (urlParameters.selectedItemGuid == null) return pathname;
  pathname += `/${urlParameters.selectedItemGuid}`;

  if (urlParameters.selectedLoadCaseGuid == null) return pathname;
  pathname += `/${urlParameters.selectedLoadCaseGuid}`;

  return pathname;
}
